import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPublicPackage } from '../../../reduxStore/actions/packageActionsHelper';
import { publicPackages$, packageLoading$ } from '../../../reduxStore/selectors/packageSelectors';
import styles from './PricingSection.module.scss';

const formatPrice = (value) =>
    new Intl.NumberFormat('en-US').format(value);

const PricingSection = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const publicPackages = useSelector(publicPackages$);
    const loading = useSelector(packageLoading$);

    useEffect(() => {
        dispatch(getPublicPackage.request());
    }, [dispatch]);

    const pkg = Array.isArray(publicPackages) ? publicPackages[0] : null;

    const price = pkg?.price_vnd ?? 1050000;
    const currency = pkg?.currency_vnd_label ?? 'VND';
    const note = pkg?.description ?? 'One time payment – lifetime access';
    const benefits = Array.isArray(pkg?.features)
        ? pkg.features
        : [
            'Lock in early access pricing forever',
            'Access all features & future builds',
            'Unlimited AI-powered practice sessions',
            'Influence the product roadmap',
        ];

    return (
        <section className={styles.pricingSection} aria-label="Pricing">
            <div className={styles.card}>
                {/* Badge */}
                <div className={styles.badge}>
                    <span className={styles.pulseDot} aria-hidden="true" />
                    <span>LOCK IN WITH FOUNDING MEMBER PRICE</span>
                </div>

                {/* Price */}
                {loading ? (
                    <div className={styles.skeleton} aria-busy="true" />
                ) : (
                    <>
                        <div className={styles.priceBlock}>
                            <span className={styles.price}>{formatPrice(price)}</span>
                            <span className={styles.currency}> {currency}</span>
                        </div>
                        <p className={styles.priceNote}>{note}</p>
                    </>
                )}

                {/* Benefits */}
                <ul className={styles.benefitsList} aria-label="Included benefits">
                    {benefits.map((b, i) => (
                        <li key={i} className={styles.benefitItem}>
                            <span className={styles.checkIcon} aria-hidden="true">✓</span>
                            {b}
                        </li>
                    ))}
                </ul>

                {/* CTA */}
                <button
                    className={styles.ctaBtn}
                    onClick={() => navigate('/pricing')}
                >
                    Start Practicing Today
                </button>

                <p className={styles.guarantee}>
                    Money-back guarantee. Secure payment.
                </p>
            </div>
        </section>
    );
};

export default PricingSection;
